import moment from 'moment'

export const DEFAULT_QUOTE_VALIDITY_DAYS = 30
export const DEFAULT_INVOICE_DUE_DAYS = 7

/** Parse a positive integer day count; otherwise return fallback. */
export function parsePositiveDays (value, fallback) {
  const n = parseInt(value, 10)
  if (!Number.isFinite(n) || n < 1) return fallback
  return n
}

/**
 * Add N calendar days to a date (moment-compatible input).
 * @param {string|Date|moment.Moment|undefined} base
 * @param {number} days
 * @returns {string} YYYY-MM-DD
 */
export function addDaysYmd (base, days) {
  const m = base
    ? moment(String(base), ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD/MM/YY'], true)
    : moment()
  const start = m.isValid() ? m : moment()
  const n = parsePositiveDays(days, DEFAULT_QUOTE_VALIDITY_DAYS)
  return start.clone().add(n, 'days').format('YYYY-MM-DD')
}

export function quoteValidityDaysFromSettings (settings) {
  return parsePositiveDays(
    settings && settings.quote_validity_days,
    DEFAULT_QUOTE_VALIDITY_DAYS
  )
}

export function invoiceDueDaysFromSettings (settings) {
  return parsePositiveDays(
    settings && settings.invoice_due_days,
    DEFAULT_INVOICE_DUE_DAYS
  )
}
